<template>
	<view class="qualification-page">

		<view class="card base-card">
			<view class="store-row">
				<image class="store-cover" @click="previewImage([info.shopAvatar],0)"  :src="(info.shopAvatar)?info.shopAvatar:'/static/icon/default2.png'"  mode="aspectFill"></image>
				<view class="store-info">
					<text class="store-name">{{info.name||''}}</text>
					<text class="store-line">联系人：{{info.linkName || ''}}</text>
					<text class="store-line">联系电话：{{info.linkPhone || ''}}</text>
				</view>
			</view>

			<view class="detail-block">
				<view class="info-row">
					<text class="info-label">省市区：</text>
					<text class="info-value">{{info.provinceName || ''}}{{info.cityName || ''}}{{info.areaName || ''}}</text>
				</view>
				<view class="info-row">
					<text class="info-label">门店地址：</text>
					<text class="info-value">{{info.address || ''}}</text>
				</view>

				<template v-if="info.companyType === 0" >
					<view class="info-row">
						<text class="info-label">身份证号：</text>
						<text class="info-value">{{info.idcard || ''}}</text>
					</view>
					<view class="material-row top-align">
						<text class="info-label">身份证：</text>
						<view class="material-list double-list">
							<image class="material-image id-card" @click="previewImage([info.idcardImgUrl],0)"  :src="info.idcardImgUrl?info.idcardImgUrl:'/static/icon/default2.png'" mode="aspectFill"></image>
							<image class="material-image id-card" @click="previewImage([info.idcardImgBackUrl],0)"   :src="info.idcardImgBackUrl?info.idcardImgBackUrl:'/static/icon/default2.png'"  mode="aspectFill"></image>
						</view>
					</view>
				</template>

				<template v-else>
					<view class="material-row top-align license-row">
						<text class="info-label">营业执照：</text>
						<view class="material-list single-list">
							<image class="material-image license-image"  @click="previewImage([info.businessImgUrl],0)" :src="info.businessImgUrl?info.businessImgUrl:'/static/icon/default2.png'" mode="aspectFill"></image>
						</view>
					</view>
				</template>
			</view>
		</view>
		
		<view style="width: 100%; height: 20rpx; background-color: #F7F7F7;"></view>
		
		<view v-if="info.companyType === 0" class="card subject-card">
			<text class="section-title">主体资质</text>
			<view class="material-group">
				<view class="material-row top-align">
					<text class="info-label" style="width: 190rpx;">有效劳动合同：</text> 
					<view v-if=" info.laborContractImgUrls" class="material-list triple-list"   > 
						<image  @click="previewImage(info.laborContractImgUrls,index)"  v-for="(item,index) in info.laborContractImgUrls" :key="item"    class="material-image contract-image"  :src="item" mode="aspectFill"></image>
					</view>
				</view>
				<view class="material-row top-align proof-row">
					<text class="info-label" style="width: 190rpx;">社保缴纳证明：</text>
					<view v-if=" info.socialSecurityImgUrls" class="material-list triple-list"   >
						<image @click="previewImage(info.socialSecurityImgUrls,index)" v-for="(item,index) in info.socialSecurityImgUrls" :key="item"    class="material-image contract-image"  :src="item" mode="aspectFill"></image>
					</view>
				</view>
			</view>
		</view>

		<view v-else class="card subject-card legal-card">
			<text class="section-title">法人信息</text>
			<view class="detail-block legal-block">
				<view class="info-row">
					<text class="info-label">法人姓名：</text>
					<text class="info-value">{{info.legalPersonName||''}}</text>
				</view>
				<view class="info-row">
					<text class="info-label">法人电话：</text>
					<text class="info-value">{{info.legalPersonPhone ||''}}</text>
				</view>
				<view class="info-row">
					<text class="info-label">身份证号：</text>
					<text class="info-value">{{info.legalPersonCard || ''}}</text>
				</view>
				<view class="material-row top-align">
					<text class="info-label">身份证：</text>
					<view class="material-list double-list">
						<image class="material-image id-card" @click="previewImage([info.idcardImgUrl],0)" :src="info.idcardImgUrl?info.idcardImgUrl:'/static/icon/default2.png'" mode="aspectFill"></image>
						<image class="material-image id-card" @click="previewImage([info.idcardImgBackUrl],0)" :src="info.idcardImgBackUrl?info.idcardImgBackUrl:'/static/icon/default2.png'" mode="aspectFill"></image>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight','shopInfo','shopToken'])
		},
		data() {
			return {
				id:null,
				qrcodeImage:null,
				showCancel:false,
				info:{}
			}
		},
		onLoad(options) {
			this.info  ={}
			this.getMyShop() 
		},
		methods:{
			previewImage(images,index = 0) {
				uni.previewImage({
					current: index, 
					urls: images  
				});
			},
			async  getMyShop(index){
					var that =this 
					let res = await that.$u.api.getShopInfoDetail()
					if (res.code === 200) { 
						this.info = res.data
						console.log(this.info.laborContractImgUrls,this.info.laborContractImgUrls.length,"====================")
						 console.log(this.info,"====================")
					} 
			}
		}
	}
</script>

<style lang="scss" scoped>
	.qualification-page {
		
	}

	.type-tabs {
		margin-bottom: 18rpx;
		display: flex;
		gap: 12rpx;
	}

	.tab-item {
		min-width: 140rpx;
		height: 56rpx;
		padding: 0 22rpx;
		border-radius: 28rpx;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24rpx;
		color: #6b7280;
		box-sizing: border-box;
	}

	.tab-item.active {
		background: #ecf8ff;
		color: #18aaf7;
		box-shadow: inset 0 0 0 2rpx #18aaf7;
	}

	.card {
		background: #ffffff;
		padding: 30rpx;
		box-sizing: border-box;
	}

	.base-card {
		padding-bottom: 16rpx;
	}

	.legal-card {
		padding-top: 18rpx;
	}

	.store-row {
		display: flex;
		align-items: center;
		padding-bottom: 30rpx;
		border-bottom: 1rpx solid #f0f1f4;
	}

	.store-cover {
		width: 144rpx;
		height: 144rpx;
		border-radius: 8rpx;
		background: #e8edf5;
		flex-shrink: 0;
	}

	.store-info {
		margin-left: 24rpx;
		min-width: 0;
	}

	.store-name {
		display: block;
		font-weight: 500;
		font-size: 32rpx;
		color: #111111;
	}

	.store-line {
		display: block;
		margin-top: 10rpx;
		font-weight: 400;
		font-size: 26rpx;
		color: #777777;
	}

	.detail-block,
	.material-group {
		padding-top: 30rpx;
	}

	.legal-block {
		padding-top: 6rpx;
	}

	.info-row,
	.material-row {
		display: flex;
		align-items: center;
		margin-bottom: 20rpx;
	}

	.material-row.top-align {
		align-items: flex-start;
	}

	.info-label {
		width: 150rpx;
		flex-shrink: 0;
		font-weight: 400;
		font-size: 26rpx;
		color: #777777;
	}

	.info-value {
		flex: 1;
		font-weight: 400;
		font-size: 26rpx;
		color: #333333;
		word-break: break-all;
	}

	.section-title {
		display: block;
		margin-bottom: 20rpx;
		font-weight: 600;
		font-size: 32rpx;
		color: #111111;
	}

	.material-list {
		flex: 1;
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		gap: 14rpx;
	}

	.material-image {
		background: #eef2f7;
		border-radius: 10rpx;
		flex-shrink: 0;
	}

	.id-card {
		width: 200rpx;
		height: 150rpx;
	}

	.contract-image {
		width: 144rpx;
		height: 144rpx;
	}

	.proof-image {
		width: 144rpx;
		height: 144rpx;
	}

	.license-image {
		width: 220rpx;
		height: 156rpx;
	}

	.proof-row {
		margin-top: 4rpx;
	}

	.license-row {
		margin-bottom: 8rpx;
	}
</style>
